/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import company_icon from '../../../images/4812244.png';
import {
  BiHome,
  BiPhone,
  BiPencil,
  BiMailSend,
} from "react-icons/bi";

import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
const SupplierBasicInfoBox = ({ t, profiledata }) => {
  return (
    <div className="card-body">
      <div className="Single_pp_Card_img text-center">
        <div className="Single_pp_Card_img_box">
          <div className="Single_pp_Card_img_box_in">
            <img src={company_icon} />
          </div>
          <div className="Change_company_img">
            <input type="file" />
            <BiPencil />
          </div>
        </div>

      </div>
      <div className="Single_pp_dt">
        <h6 className="text-center">
          {profiledata?.supplier.legalName}
        </h6>
        <p className="text-center">
          {profiledata.supplier.address.building},{" "}
          {profiledata.supplier.address.street},{" "}
          {profiledata.supplier.address.state.name},{" "}
          {profiledata.supplier.address.country.name} -{" "}
          {profiledata.supplier.address.zipCode}
        </p>
        <ul>
          <li>
            <BiPhone /> +
            {
              profiledata.supplier.primaryContact.contactNumber.code
                .phoneCode
            }{" "}
            {
              profiledata.supplier.primaryContact.contactNumber
                .number
            }
          </li>
          <li>
            <BiMailSend />{" "}
            {profiledata.supplier.primaryContact.email}
          </li>
        </ul>
      </div>
    </div>
  );
};
export default withTranslation()(SupplierBasicInfoBox);
